module.exports = __webpack_public_path__ + "img/communication13.62dbcb01.png";